import * as React from 'react';
import { TileViewProps } from 'ui/tile-view';
import { AddDocumentItemOptions, DeleteDocumentItemOptions } from 'app/infrastructure/ui/form/types';
import { ConnectCaseSelector } from 'app/area/case/components/connected-cases/connect-case-selector';
import { TileView } from 'ui';

export interface ConnectedCasesTileViewProps extends TileViewProps {
  entityId: number;
  caseId: number;
  connectionTypeId: number;
  maxSequence: number;
  stateForCaseIds: {[caseId: string]: { valid: boolean, fetching: boolean }};
  validateCaseId: (caseId: number) => void;
  onAddDocumentItem: (selectAddedItem?: boolean, options?: AddDocumentItemOptions) => void;
  onDeleteDocumentItem: (selectParentItem: boolean, options?: DeleteDocumentItemOptions) => void;
  createSearchForCasesToConnect: (draftId: number, connectionTypeId: number) => Promise<number>;
  allowConnectCases: boolean;
  allowDisconnectCases: boolean;
  textAddExisting: string;
  textAddNew: string;
  textNoConnectionToItself: string;
  textConnect: string;
  textDisconnect: string;
  placeholderSearch: string;
  titleSearch: string;
  textInvalidRangeError: string;
  connectedDrafts?: any[];
  favouriteComponent: React.ComponentType<any>;
}

export class ConnectedCasesTileView extends React.PureComponent<ConnectedCasesTileViewProps, {}> {

  public static defaultProps: Partial<ConnectedCasesTileViewProps> = {
    allowConnectCases: false,
    allowDisconnectCases: false
  };

  private createSearchForCasesToConnect = (): Promise<number> => {
    return this.props.createSearchForCasesToConnect(this.props.entityId, this.props.connectionTypeId);
  }

  public render() {
    const {
      connectionTypeId,
      allowConnectCases
    } = this.props;

    const required = this.props.label && this.props.label.required;

    const addButton = !!allowConnectCases &&
      <ConnectCaseSelector {
        ...{
          ...this.props, required, children: undefined,
          connectionTypeId,
          createSearchForCasesToConnect: this.createSearchForCasesToConnect
        }}
      />;

    return (
      <TileView {...{...this.props, readOnly: !allowConnectCases, addButton}} />
    );
  }
}

// tslint:disable: max-line-length no-console
export const ConnectedCasesTileViewEdit = (props: any) => <ConnectedCasesTileView allowConnectCases={!props.readOnly} allowDisconnectCases={!props.readOnly} {...props} />;
